import { Component, Input } from '@angular/core';
import { ServiceLineMetric } from '@shared/models/service-line-metric.model';
import { TabConfig } from '@shared/models/table-config.model';

@Component({
    selector: 'app-table-expanded-view',
    templateUrl: './table-expanded-view.component.html',
    styleUrls: ['./table-expanded-view.component.scss'],
    standalone: false
})
export class TableExpandedViewComponent {
  @Input() tabs!: TabConfig[];
  @Input() data!: ServiceLineMetric;
}
